"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c51ca4d64{max-width:100%;position:relative}.c0e1b9637{visibility:hidden}.c7182fc75{position:absolute;overflow:visible}.c1c52f148{display:block;fill:transparent;stroke-linecap:round;opacity:.2}.cedf3495c{position:absolute;overflow:visible;-webkit-animation:c2103605b 2s linear infinite;animation:c2103605b 2s linear infinite}@-webkit-keyframes c2103605b{0%{-webkit-transform:rotateZ(0);transform:rotateZ(0)}100%{-webkit-transform:rotateZ(360deg);transform:rotateZ(360deg)}}@keyframes c2103605b{0%{-webkit-transform:rotateZ(0);transform:rotateZ(0)}100%{-webkit-transform:rotateZ(360deg);transform:rotateZ(360deg)}}.c1363491c{-webkit-animation:c240e39b0 1.4s ease-in-out infinite both;animation:c240e39b0 1.4s ease-in-out infinite both;display:block;fill:transparent;stroke-linecap:round;stroke-dasharray:283;stroke-dashoffset:280;-webkit-transform-origin:50% 50%;transform-origin:50% 50%}.caa653b81 .c1c52f148{stroke:var(--color-flomni-blue-70)}.caa653b81 .c1363491c{stroke:var(--color-flomni-blue-70)}.c486646b5 .c1c52f148{stroke:#fff}.c486646b5 .c1363491c{stroke:#fff}@-webkit-keyframes c240e39b0{0%,25%{stroke-dashoffset:280;-webkit-transform:rotate(0);transform:rotate(0)}50%,75%{stroke-dashoffset:75;-webkit-transform:rotate(45deg);transform:rotate(45deg)}100%{stroke-dashoffset:280;-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes c240e39b0{0%,25%{stroke-dashoffset:280;-webkit-transform:rotate(0);transform:rotate(0)}50%,75%{stroke-dashoffset:75;-webkit-transform:rotate(45deg);transform:rotate(45deg)}100%{stroke-dashoffset:280;-webkit-transform:rotate(360deg);transform:rotate(360deg)}}");
var styles = {
  root: 'c51ca4d64',
  shape: 'c0e1b9637',
  bg: 'c7182fc75',
  rail: 'c1c52f148',
  spinner: 'cedf3495c',
  'animation-one': 'c2103605b',
  circle: 'c1363491c',
  'animation-two': 'c240e39b0',
  '--view-usual': 'caa653b81',
  '--view-light': 'c486646b5'
};

var Spinner = function Spinner(props) {
  var classes = props.classes,
      view = props.view,
      strokeWidth = props.strokeWidth;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: cn.bg,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: cn.rail,
    strokeWidth: strokeWidth,
    cx: "50",
    cy: "50",
    r: "45"
  })), /*#__PURE__*/_react.default.createElement("svg", {
    className: cn.spinner,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: cn.circle,
    strokeWidth: strokeWidth,
    cx: "50",
    cy: "50",
    r: "45"
  })), /*#__PURE__*/_react.default.createElement("svg", {
    className: cn.shape,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    strokeWidth: strokeWidth,
    cx: "50",
    cy: "50",
    r: "45"
  })));
};

exports.Spinner = Spinner;
var view = ['usual', 'light'];
Spinner.modes = {
  view: view
};
Spinner.propTypes = {
  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  strokeWidth: _propTypes.number,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Spinner.defaultProps = {
  classes: {},
  view: 'usual',
  strokeWidth: 1.6
};